<template>
    <v-app>
    <Drawer current_item="menu_staff"></Drawer>
        <v-main v-if="permission.includes('VIEW_station_detail')">

            <v-banner single-line :sticky="true" style="background-color:white">
                <v-row align="end" justify="space-between">
                    <v-col cols="12" md="8" class="text-md-h4 text-h5" align="left">
                        #{{ $route.params.station_code }}
                        </v-col>
                    <v-col cols="12" md="4" align="left">
                        <v-btn v-if="permission.includes('EDIT_station_detail')" tile color="success" @click="submitChange" :disabled="!is_change" >
                            <v-icon left>mdi-check</v-icon>{{ $t('config_submit') }}
                        </v-btn>
                    </v-col>

                </v-row>
            </v-banner>

            <v-divider></v-divider>

            <div class="ml-6 mr-6">
                
                <v-card
                    class="mx-auto mt-4 mr-6 pa-4"
                    outlined
                    elevation=3
                >
                    <FragmentStationDescription
                        :station_name="station_name"
                        :logo="logo"
                        :banner="banner"
                        :station_detail="station_detail"
                        :station_code="$route.params.station_code"
                        :onchange="onchange"
                        :station_annooucement_welcome="station_annooucement_welcome"
                        :station_annooucement_ula="station_annooucement_ula"
                        @onupload="reload"
                        :disabled="!permission.includes('EDIT_station_detail')"
                    ></FragmentStationDescription>
                </v-card>

                <v-card
                    class="mx-auto mt-4 mr-6 pa-4"
                    outlined
                    elevation=3
                >
                    <FragmentStationBuyer
                        :BuyerTaxID="BuyerTaxID"
                        :BuyerName="BuyerName"
                        :BuyerBranchName="BuyerBranchName"
                        :BuyerBranchNo="BuyerBranchNo"
                        :BuyerAddress="BuyerAddress"
                        :BuyerBuildingName="BuyerBuildingName"
                        :BuyerBuildingNo="BuyerBuildingNo"
                        :BuyerStreetName="BuyerStreetName"
                        :BuyerDistinct="BuyerDistinct"
                        :BuyerCity="BuyerCity"
                        :BuyerProvince="BuyerProvince"
                        :BuyerPostalCode="BuyerPostalCode"
                        :BuyerCountryCode="BuyerCountryCode"
                        :BuyerPhoneNumber="BuyerPhoneNumber"
                        :BuyerElectronicEmail="BuyerElectronicEmail"
                        :onchange="onchange"
                        :disabled="!permission.includes('EDIT_station_detail')"
                    ></FragmentStationBuyer>
                </v-card>

                
                <v-card
                    class="mx-auto mt-4 mr-6 pa-4"
                    outlined
                    elevation=3
                >
                    <FragmentStationLimitation
                        :line_message_count="line_message_count"
                        :user_count="user_count"
                        :onchange="onchange"
                        :disabled="!permission.includes('EDIT_station_detail')"
                    ></FragmentStationLimitation>
                </v-card>

                
                <v-card
                    class="mx-auto mt-4 mr-6 pa-4"
                    outlined
                    elevation=3
                >
                    <FragmentStationUserRequire
                        :user_register_mode = "user_register_mode"
                        :user_register_mode_items = "user_register_mode_items"
                        :staff_register_mode = "staff_register_mode"
                        :staff_register_mode_items = "staff_register_mode_items"
                        :user_register_form = "user_register_form"
                        :onchange="onchange"
                        :disabled="!permission.includes('EDIT_station_detail')"
                    ></FragmentStationUserRequire>
                </v-card>

                
                <v-card
                    class="mx-auto mt-4 mr-6 pa-4"
                    outlined
                    elevation=3
                >
                    <FragmentStationAppointment 
                        :reservation_enable = "reservation_enable"
                        :line_reservation_enable = "line_reservation_enable"
                        :onchange="onchange"
                        :disabled="!permission.includes('EDIT_station_detail')"
                        :reserve_station_dup_day = "reserve_station_dup_day"
                        :reserve_station_dup_week = "reserve_station_dup_week"
                        :reserve_station_dup_month = "reserve_station_dup_month"
                        :reserve_station_dup_all = "reserve_station_dup_all"
                    ></FragmentStationAppointment>
                </v-card>
            </div>


        </v-main>
    </v-app>
</template>

<script>
import Drawer from '@/components/Drawer.vue'
import FragmentStationDescription from '@/components/Station/FragmentStationDescription.vue'
import FragmentStationLimitation from '@/components/Station/FragmentStationLimitation.vue'
import FragmentStationUserRequire from '@/components/Station/FragmentStationUserRequire.vue'
import FragmentStationAppointment from '@/components/Station/FragmentStationAppointment.vue'
import FragmentStationBuyer from '@/components/Station/FragmentStationBuyer.vue'

import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';

export default {
    components: {
        Drawer
        ,FragmentStationDescription
        ,FragmentStationLimitation
        ,FragmentStationUserRequire
        ,FragmentStationAppointment
        ,FragmentStationBuyer
    },
    data () {
        return {
            station_name:""
            ,logo: require('@/assets/logo-default.jpg')
            ,banner: require('@/assets/banner-default.jpg')
            ,station_detail:""
            ,station_annooucement_welcome:""
            ,station_annooucement_ula:""

            ,BuyerTaxID : ""
            ,BuyerName : ""
            ,BuyerBranchName : ""
            ,BuyerBranchNo : ""
            ,BuyerAddress : ""
            ,BuyerBuildingName : ""
            ,BuyerBuildingNo : ""
            ,BuyerStreetName : ""
            ,BuyerDistinct : ""
            ,BuyerCity : ""
            ,BuyerProvince : ""
            ,BuyerPostalCode : ""
            ,BuyerCountryCode : ""
            ,BuyerPhoneNumber : ""
            ,BuyerElectronicEmail : ""

            ,line_message_count:""
            ,user_count:""
            ,user_register_mode:{name:"",desc:"",val:""}
            ,staff_register_mode:{name:"",desc:"",val:""}
            ,old_user_register_form:[]
            ,user_register_form:[]
            ,user_register_mode_items: [
                {name:this.$i18n.t('user_register_mode_guest_name'),desc:this.$i18n.t('user_register_mode_guest_desc'),val:'guest'}
                ,{name:this.$i18n.t('user_register_mode_user_form_name'),desc:this.$i18n.t('user_register_mode_user_form_desc'),val:'user_form'}
                ,{name:this.$i18n.t('user_register_mode_user_register_name'),desc:this.$i18n.t('user_register_mode_user_register_desc'),val:'user_register'}
            ],
            staff_register_mode_items: [
                {name:this.$i18n.t('staff_register_mode_user_request_name'),desc:this.$i18n.t('staff_register_mode_user_request_desc'),val:'user_request'}
                ,{name:this.$i18n.t('staff_register_mode_user_form_name'),desc:this.$i18n.t('staff_register_mode_user_form_desc'),val:'user_form'}
                ,{name:this.$i18n.t('staff_register_mode_auto_accept_name'),desc:this.$i18n.t('staff_register_mode_auto_accept_desc'),val:'auto_accept'}
            ]
            ,reservation_enable:"false"
            ,line_reservation_enable:"true"
            ,reserve_station_dup_day:"-1"
            ,reserve_station_dup_week:"-1"
            ,reserve_station_dup_month:"-1"
            ,reserve_station_dup_all:"-1"

            ,change_list : {}
            ,is_change : false
            ,permission : []
        }
    },
    mounted: function () {
        var que = this.$store.commit('addLoading')
        this.permission = Staff.getPermission('StationDetail',this.$route.params.station_code).then(permission=>{
            this.permission = permission
            this.$store.commit('finishLoading',que)
        })
        this.reload()
    },
    methods: {
      reload () {
        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.manage.station.get_stationdetail,{station_code:this.$route.params.station_code},{ headers: Staff.getTokenHeader()})
        .then(response => {

            this.station_name = response.data.station_name
            if(response.data.logo.length>0) this.logo = response.data.logo
            if(response.data.banner.length>0) this.banner = response.data.banner
            this.station_detail = response.data.station_detail

            this.station_annooucement_welcome = response.data.station_annooucement_welcome
            this.station_annooucement_ula = response.data.station_annooucement_ula

        
            this.BuyerTaxID  = response.data.BuyerTaxID
            this.BuyerName  = response.data.BuyerName
            this.BuyerBranchName  = response.data.BuyerBranchName
            this.BuyerBranchNo  = response.data.BuyerBranchNo
            this.BuyerAddress  = response.data.BuyerAddress
            this.BuyerBuildingName  = response.data.BuyerBuildingName
            this.BuyerBuildingNo  = response.data.BuyerBuildingNo
            this.BuyerStreetName  = response.data.BuyerStreetName
            this.BuyerDistinct  = response.data.BuyerDistinct
            this.BuyerCity  = response.data.BuyerCity
            this.BuyerProvince  = response.data.BuyerProvince
            this.BuyerPostalCode  = response.data.BuyerPostalCode
            this.BuyerCountryCode  = response.data.BuyerCountryCode
            this.BuyerPhoneNumber  = response.data.BuyerPhoneNumber
            this.BuyerElectronicEmail  = response.data.BuyerElectronicEmail

            this.line_message_count = response.data.line_message_count
            this.user_count = response.data.user_count

            this.user_register_mode_items.forEach(i=>{
                if(i.val == response.data.user_register_mode ) this.user_register_mode = i
            })

            this.staff_register_mode_items.forEach(i=>{
                if(i.val == response.data.staff_register_mode ) this.staff_register_mode = i
            })

            this.old_user_register_form = response.data.user_register_form
            this.user_register_form  = []
            this.old_user_register_form.forEach(f=>{
                var form_tag = f.form_tag
                var is_required = f.is_required
                this.user_register_form.push({
                    form_tag:form_tag
                    ,is_required:is_required
                })
            })

            this.reservation_enable = response.data.reservation_enable == 'true'
            this.line_reservation_enable = response.data.line_reservation_enable == 'true'

            this.reserve_station_dup_day = response.data.reserve_station_dup_day
            this.reserve_station_dup_week = response.data.reserve_station_dup_week
            this.reserve_station_dup_month = response.data.reserve_station_dup_month
            this.reserve_station_dup_all = response.data.reserve_station_dup_all

            this.is_change = false
            this.change_list = {}
            this.$store.commit('finishLoading',que)
        })
        .catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
      },
      onchange(field,val) {
        let isChange = false;

        if(['user_register_mode','staff_register_mode'].includes(field)){
            if(val.val != this[field].val){
                isChange = true;
                this.change_list[field] = {
                    field : field
                    ,toid : this.$route.params.station_code
                    ,params : {
                        station_code : this.$route.params.station_code
                        ,setting_tag : field
                        ,setting_value : val.val
                    }
                }
            }
        }
        else if(field=='user_register_form'){
            var isFormChange = false
            if(this.old_user_register_form.length != val.length){
                isFormChange = true;
            }else{
                this.old_user_register_form.forEach((f,i)=>{
                    if(f.form_tag != val[i].form_tag || f.is_required != val[i].is_required){
                        isFormChange = true
                    }
                })
            }

            if(isFormChange){
                isChange = true;
                this.change_list[field] = {
                    field : field
                    ,toid : this.$route.params.station_code
                    ,params : {
                        station_code : this.$route.params.station_code
                        ,setting_tag : field
                        ,setting_value : val
                    }
                }
            }
        }
        else if(val != this[field]){
            isChange = true;
            this.change_list[field] = {
                field : field
                ,toid : this.$route.params.station_code
                ,params : {
                    station_code : this.$route.params.station_code
                    ,setting_tag : field
                    ,setting_value : '' + val
                }
            }
        }

        if(!isChange){
            delete this.change_list[field];
        }
        this.is_change = Object.keys(this.change_list).length > 0
      },
      submitChange(){
        var que = this.$store.commit('addLoading')
        var change_data = [];
        Object.keys(this.change_list).forEach(k=>{
            change_data.push(this.change_list[k]);
        });
        axios
        .post(config.api.url.manage.save.config,{editlist:change_data},{ headers: Staff.getTokenHeader()})
        .then(() => {
            this.$store.commit('finishLoading',que)
            this.reload()
        }).catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
      }
    }
}
</script>